var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoPadlockClosed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 17,
    viewBox: "0 0 11 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.20833 1.04167C6.35893 1.04167 7.29167 1.97441 7.29167 3.125V7.29167H3.125V3.125C3.125 1.97441 4.05774 1.04167 5.20833 1.04167ZM8.33333 7.29167V3.125C8.33333 1.39911 6.93422 0 5.20833 0C3.48244 0 2.08333 1.39911 2.08333 3.125V7.29167C0.93274 7.29167 0 8.22441 0 9.375V14.5833C0 15.7339 0.93274 16.6667 2.08333 16.6667H8.33333C9.48393 16.6667 10.4167 15.7339 10.4167 14.5833V9.375C10.4167 8.22441 9.48393 7.29167 8.33333 7.29167Z",
    fill: "inherit"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoPadlockClosed);
export default __webpack_public_path__ + "static/media/ico-padlock-closed.842c2270cee9e8fa59661294b0c594de.svg";
export { ForwardRef as ReactComponent };